import type { AlertOutcomeType } from 'src/store/sageAdminApi';

export const AlertOutcomeTypes = {
    ResidentInteraction: 'RESIDENT_INTERACTION',
    TestAlert: 'TEST_ALERT',
    FalseAlarm: 'FALSE_ALARM',
} as const satisfies Record<string, AlertOutcomeType>;

export type { AlertOutcomeType };
